<template>
  <table-list
      ref="list"
      @query="handleLoadList"
      :request-params="{userNum: 'PH36853478'}"
      v-bind="$attrs"
      :data="tableData">
    <el-table-column align="center" :label="$t('评论编号')" prop="num" />
    <el-table-column align="center" :label="$t('菜谱编号')" prop="cookbookNum" />
    <el-table-column align="center" :label="$t('图片')">
      <template v-slot="{row}">
        <preview-img :img-url="row.photo" :size="60" />
      </template>
    </el-table-column>
    <el-table-column align="center" prop="name" :label="$t('名称')" />
    <el-table-column align="center" prop="content" :label="$t('评论内容')" />
    <el-table-column align="center" :label="$t('发布时间')">
      <template v-slot="{row}">{{row.createTime | formatDate}}</template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "RecipeComments",
  components: {PreviewImg, TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.cookbookComment.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        this.tableData = this.tableData;
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
  height: 70px;
  border-radius: 10px;
}
</style>
